export default __webpack_public_path__ + "70e8d815e7d07b1f73a10d5d86d40097.png";